import { createFileRoute } from '@tanstack/react-router';
import { useVisitActions } from '../../features/visits/VisitActions';
import { VisitsPage } from '../../features/visits/VisitsPage';
import { fromSearchParams, toSearchParams, visitSearchSchema } from '../../features/visits/search';

export const Route = createFileRoute('/_authed/cancelled')({
  validateSearch: visitSearchSchema,
  component: CancelledRoute,
});

function CancelledRoute(): React.JSX.Element {
  const params = Route.useSearch();
  const navigate = Route.useNavigate();
  const actions = useVisitActions();
  return (
    <>
      <VisitsPage
        title="Cancelled Visits"
        cancelledView
        search={fromSearchParams(params)}
        onSearch={(next) => void navigate({ search: toSearchParams(next) })}
        actions={actions.renderActions}
        onOpen={actions.openTimeline}
      />
      {actions.modals}
    </>
  );
}
